
<kendo-formfield>
    <kendo-label *ngIf="!!caption" [text]="caption | translate"></kendo-label>
    <kendo-combobox
    [ngClass]="{'fx-fill': settings.fxFill}"
    [formControl]="control"
    valuePrimitive="true"
    [data]="displayList$ | async"
    [textField]="textField"
    [valueField]="valueField"
    (valueChange)="onChange($event)"
    [filterable]="true"
    (filterChange)="filterChange($event)"
    [allowCustom]="allowCustom">
    </kendo-combobox>
</kendo-formfield>
